// Mock data pour le site SISENS
export const categories = [
  {
    id: 1,
    title: "Hospitality restauration",
    description: "Chez SISENS, nous dépassons le cadre classique de la restauration collective. Nos espaces deviennent des lieux de vie ouverts toute la journée, pensés pour tous les moments de consommation : petit déjeuner, pause, déjeuner, goûter, dîner à emporter. Ils intègrent des services de conciergerie, du wifi, un coffee shop en libre-service ou au comptoir, et une plateforme digitale pour animer, informer et commander.",
    icon: "Crown"
  },
  {
    id: 2,
    title: "Restauration d'entreprise et d'administration",
    description: "Nous réinventons le restaurant d'entreprise en lui redonnant sa dimension sociale et conviviale. Une assiette plus cuisinée, plus généreuse, pensée pour le partage, le bien-être au travail et la qualité nutritionnelle. Nos équipes assurent un service de proximité, avec une attention particulière à l'équilibre alimentaire, à la saisonnalité et à l'écoute des convives. Une solution idéale pour les entreprises et administrations souhaitant moderniser leur restauration tout en conservant un format classique et structurant.",
    icon: "Building"
  },
  {
    id: 3,
    title: "Restauration scolaire privée et post bac",
    description: "Nous accompagnons les établissements scolaires dans leur transition vers une restauration moderne, responsable et attractive. Nos offres s'adaptent aux attentes des jeunes générations : Food court, restauration rapide, parcours digitaux. Cuisine du monde, produits locaux et bio, anti-gaspi. Des espaces pensés pour le plaisir, la rapidité, et la découverte culinaire. Une restauration qui éduque au goût, à la diversité et à la responsabilité.",
    icon: "GraduationCap"
  },
  {
    id: 4,
    title: "Restauration commerciale",
    description: "SISENS, c'est aussi une expertise de terrain en gestion de restaurants, brasseries et concepts de restauration rapide. Nous sommes des commerçants inspirés, à l'écoute des tendances, des flux et des attentes clients. Notre savoir-faire s'appuie sur une vision entrepreneuriale, une maîtrise des coûts, et une créativité culinaire. Nous intervenons en gestion complète ou en accompagnement stratégique pour faire de chaque lieu un point de destination.",
    icon: "Store"
  },
  {
    id: 5,
    title: "Café-Epicerie",
    description: "Un concept unique, à la croisée du snacking frais, de l'épicerie locale et du service ultra-pratique. Pensé pour les lieux à forte fréquentation ou à horaires étendus, le Café-Epicerie propose : Des produits frais, locaux et healthy. Une offre rapide et accessible, sans compromis sur la qualité. Une amplitude horaire large, pour répondre à tous les rythmes. Un espace hybride, entre restauration, coffee shop et épicerie de quartier. C'est la solution idéale pour dynamiser un hall, un campus, un espace de coworking ou un quartier, avec du goût, du service et de la simplicité.",
    icon: "Coffee"
  },
  {
    id: 6,
    title: "Service Daily Pronto",
    description: "Notre solution mobile et agile, idéale pour les immeubles tertiaires, espaces de coworking ou entreprises en quête de flexibilité. Un kiosque sur-mesure, un Daily Maker dédié, une restauration saine et locale, un coffee shop Mokxa, et des services de conciergerie intégrés. Sans investissement ni engagement, avec une mise en place rapide et une forte valeur ajoutée pour les usagers.",
    icon: "Zap"
  }
];

export const companyInfo = {
  name: "SISENS",
  tagline: "Bien manger, bien vivre, bien ensemble",
  description: "SISENS réinvente la restauration collective avec agilité, innovation et écoute. Fier de nos racines lyonnaises, nous allions tradition et modernité pour créer des expériences culinaires responsables, locales et gourmandes. Notre cuisine et nos services transforment les lieux de vie en espaces chaleureux, connectés et porteurs de bien-être.",
  phone: "06 12 60 68 70",
  email: "contact@sisens.eu",
  address: "Adresse à définir"
};

export const services = [
  {
    title: "Restauration collective",
    description: "Service de restauration quotidienne pour entreprises, avec des menus variés et équilibrés."
  },
  {
    title: "Événementiel",
    description: "Organisation complète d'événements culinaires sur mesure pour vos occasions spéciales."
  },
  {
    title: "Formation culinaire",
    description: "Sessions de formation et workshops culinaires pour vos équipes et collaborateurs."
  }
];